import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'shards-react';
import Crud from '../../components/Crud';
import { InputText } from '../../components/FormHelper/Input';
import AuthContext from '../../context/auth';

const FormWrapper = ({ Field, ErrorMessage }) => {
    const { t } = useTranslation();
    return (
        <>
            <Row container spacing={2}>
                <Col item sx={12} md={2}>
                    <Field 
                        id="id"
                        label={t('Codigo')}
                        name="id"
                        component={InputText}
                        disabled
                        error={<ErrorMessage name="id" />}
                    />
                </Col>
                <Col item sx={12} md={5}>
                    <Field 
                        required
                        id="name"
                        label={t('Título PT')}
                        name="name"
                        component={InputText}
                        error={<ErrorMessage name="name" />}
                    />
                </Col>
                <Col item sx={12} md={5}>
                    <Field 
                        required
                        id="name_en"
                        label={t('Título EN')}
                        name="name_en"
                        component={InputText}
                        error={<ErrorMessage name="name_en" />}
                    />
                </Col>
            </Row>            
        </>
    );
}

export default function Briefings() {

    const { t } = useTranslation();

    return (
        <Crud 
            title={t('Briefings')}
            subtitle={t('Cadastros')}
            endPoint="briefings"
            searchFieldName="search"
            emptyObject={{
                name: '',
                name_en: ''
            }}
            fields={[
                { name: 'id', label: 'Id', classBody: 'min-width' },
                { name: 'name', label: t('Nome') }
            ]}
            validation={(yup) => {
                return {
                    name: yup.string().required(t('Campo obrigatorio')),
                    name_en: yup.string().required(t('Campo obrigatorio')),
                };
            }}
            FormWrapper={FormWrapper}
        />
    );
}
